module.exports = __webpack_public_path__ + "static/media/actionresponse-individual.f33fdfde.svg";